import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import decode from "jwt-decode";

import Logo from "../../images/logo.svg";

import { LOGOUT } from "../../constants/actionTypes";
import Document from "./SVG/document.svg";
import Certificate from "./SVG/certificate.svg";
import Education from "./SVG/education.svg";
import Transcript from "./SVG/transcript.svg";
import Additional from "./SVG/additional.svg";
import Commercial from "./SVG/commercial.svg";
import Research from "./SVG/research.svg";
import Personal from "./SVG/personal.svg";
import Legal from "./SVG/legal.svg";
import Industries from "./SVG/industries.svg";
import Privacy from "./SVG/privacy.svg";
import Apostille from "./SVG/apostille.svg";
import Notarized from "./SVG/notarized.svg";
import Diploma from "./SVG/diploma.svg";
import Content from "./SVG/content.svg";
import Marketing from "./SVG/marketing.svg";
import Certified from "./SVG/certified.svg";
import Sworn from "./SVG/sworn.svg";
import Press from "./SVG/press.svg";
import Onsite from "./SVG/onsite.svg";
import Conference from "./SVG/conference.svg";
import Consecutive from "./SVG/consecutive.svg";
import Equipment from "./SVG/equipment.svg";
import Host from "./SVG/host.svg";
import OverPhone from "./SVG/over-the-phone.svg";
import Sign from "./SVG/sign.svg";
import Training from "./SVG/training.svg";
import Convention from "./SVG/conventional.svg";
import Classrooms from "./SVG/classrooms.svg";
import Languages from "./SVG/languages.svg";
import Services from "./SVG/services.svg";
import About from "./SVG/about-us.svg";
import Offices from "./SVG/offices.svg";
import Photos from "./SVG/photos.svg";
import Why from "./SVG/why.svg";
import Request from "./SVG/request.svg";
import Process from "./SVG/process.svg";
import Blog from "./SVG/blog.svg";
import FAQ from "./SVG/faq.svg";
import TranscriptRate from "./SVG/transcription.svg";
import Card from "./SVG/card.svg";

import {
  ArrowDropDown,
  Close,
  DashboardOutlined,
  ExitToApp,
  Facebook,
  Instagram,
  LinkedIn,
  Menu,
  SettingsOutlined,
  Twitter,
} from "@material-ui/icons";

import "./NavBar.css";

const NavBar = ({
  white,
  translation,
  interpretation,
  languages,
  pricing,
  company,
  home,
  join,
  online,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [showSide, setShowSide] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("auth")));

  const logout = useCallback(() => {
    document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    setShowSide(false);

    if (!user || location.pathname === "/settings")
      history.push("/auth/signin");

    setUser(null);
    dispatch({ type: LOGOUT });
  }, [dispatch, history, location, user]);

  const handleToDashboard = () => {
    if (user.role === "basic") history.push("/projects/index");
    if (user.role === "translator") history.push("/translator/profile");
    if (user.role === "admin") history.push("/admin/index");
  };

  const handleToCheckout = () => {
    history.push("/quote");
    setShowSide(false);
  };

  useEffect(() => {
    const token = user?.token;

    if (token) {
      const decodedToken = decode(token);

      if (decodedToken.exp * 1000 < new Date().getTime()) logout();
    }
  }, [user, location, logout]);

  useEffect(() => {
    if (showSide) {
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    }
  }, [showSide]);

  let oldValue = 0;
  let newValue = 0;
  let oldValueLg = 0;
  let newValueLg = 0;

  window.addEventListener("scroll", (e) => {
    if (window.innerWidth < 1025) {
      const navBar = document.querySelector(".navBar__sm__scroll");

      newValue = window.pageYOffset;

      if (navBar && oldValue < newValue) {
        navBar.style.cssText =
          "position: fixed; top: -50px; width: 100vw; z-index: 5;";
      } else if (oldValue > newValue) {
        if (navBar && newValue > 600) {
          navBar.style.cssText =
            "position: fixed; top: 0; width: 100vw; z-index: 5;";
        } else if (navBar && newValue < 601) {
          navBar.style.cssText =
            "position: fixed; top: -50px; width: 100vw; z-index: 5;";
        }
      }
      oldValue = newValue;
    } else {
      const navBarLg = document.querySelector(".navBar__lg");

      newValueLg = window.pageYOffset;

      if (navBarLg && oldValueLg < newValueLg) {
        navBarLg.style.cssText =
          "position: fixed; top: -500px; width: 100vw; z-index: 5;";
      } else if (navBarLg && oldValueLg > newValueLg) {
        if (newValueLg > 600) {
          navBarLg.style.cssText =
            "position: fixed; top: 0; width: 100vw; z-index: 5;";
        } else if (navBarLg && newValueLg < 601) {
          navBarLg.style.cssText =
            "position: fixed; top: -500px; width: 100vw; z-index: 5;";
        }
      }
      oldValueLg = newValueLg;
    }
  });

  return (
    <>
      {showSide && (
        <div
          className="navBar__overlay position-fixed w-100 h-100 z-5"
          onClick={() => setShowSide(false)}
        ></div>
      )}
      <div
        className="navBar__lg position-fixed box-shadow-lg z-5 w-100"
        style={{ color: white ? "var(--bg-dark)" : "#fff" }}
      >
        <div className="container d-flex align-center w-100 justify-between z-3">
          <Link to="/">
            <div className="navBar__logo m-10">
              <img src={Logo} alt="OneConverse" />
            </div>
          </Link>
          <nav className="navBar__menu d-flex">
            <div className="navBar__translation mx-20">
              <Link
                to="/translation"
                style={{
                  color: translation
                    ? "var(--primary-color)"
                    : !white
                    ? "#333"
                    : "#fff",
                }}
                className="position-relative font-bolder font-sm pointer"
              >
                Translation
              </Link>
              <div className="navBar__line"></div>
              <div className="navBar__links position-absolute mt-10 z-2">
                <div className="navBar__link">
                  <Link className="" to="/on/document-translations">
                    <img src={Document} alt="" />
                    <span>Document Translation</span>
                  </Link>
                  <Link className="" to="/on/certificate-translation">
                    <img src={Certificate} alt="" />
                    <span>Certificate Translation</span>
                  </Link>
                  <Link className="" to="/on/covenant-translation">
                    <img src={Education} alt="" />
                    <span>Contract Translation</span>
                  </Link>
                  <Link className="" to="/on/affidavits-translation">
                    <img src={Transcript} alt="" />
                    <span>Affidavitis Translation</span>
                  </Link>
                  <Link className="" to="/services">
                    <img src={Additional} alt="" />
                    <span>Additional Services</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/on/government-translation">
                    <img src={Commercial} alt="" />
                    <span>Government Translation</span>
                  </Link>
                  <Link className="" to="/on/business-document">
                    <img src={Research} alt="" />
                    <span>Business Translation</span>
                  </Link>
                  <Link className="" to="/on/personal-translation">
                    <img src={Personal} alt="" />
                    <span>Personal Translation</span>
                  </Link>
                  <Link className="" to="/on/legal-translation">
                    <img src={Legal} alt="" />
                    <span>Legal Translation</span>
                  </Link>
                  <Link className="" to="/industries">
                    <img src={Industries} alt="" />
                    <span>All Industries</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/on/patents-translations">
                    <img src={Privacy} alt="" />
                    <span>Patents Translation</span>
                  </Link>
                  <Link className="" to="/on/apostile-transltion">
                    <img src={Apostille} alt="" />
                    <span>Apostille Translation</span>
                  </Link>
                  <Link className="" to="/on/notarized-translation">
                    <img src={Notarized} alt="" />
                    <span>Notarized Translation</span>
                  </Link>
                  <Link className="" to="/on/thesis-translations">
                    <img src={Diploma} alt="" />
                    <span>Thesis Translation</span>
                  </Link>
                  <Link className="" to="/on/website-content-translation">
                    <img src={Content} alt="" />
                    <span>Web Content Translation</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/on/marketing-materials-translation">
                    <img src={Marketing} alt="" />
                    <span>Marketing Materials Translation</span>
                  </Link>
                  <Link className="" to="/on/certified-document-translation">
                    <img src={Certified} alt="" />
                    <span>Certified Document Translation</span>
                  </Link>
                  <Link className="" to="/on/sworn-document-translation">
                    <img src={Sworn} alt="" />
                    <span>Sworn Document Translation</span>
                  </Link>
                  <Link className="" to="/on/financial-translation">
                    <img src={Press} alt="" />
                    <span>Financial Translation</span>
                  </Link>
                  <Link className="" to="/on/pledge-translation">
                    <img src={Privacy} alt="" />
                    <span>Pledge Translation</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="navBar__interpreting mx-20">
              <Link
                to="/interpretation"
                style={{
                  color: interpretation
                    ? "var(--primary-color)"
                    : !white
                    ? "#333"
                    : "#fff",
                }}
                className="position-relative font-bolder font-sm pointer"
              >
                Interpreting
              </Link>
              <div className="navBar__line"></div>
              <div className="navBar__links position-absolute mt-10 z-2">
                <div className="navBar__link">
                  <Link className="" to="/on/onsite-interpreting">
                    <img src={Onsite} alt="" />
                    <span>Onsite Interpretation</span>
                  </Link>
                  <Link className="" to="/on/conference-interpretation">
                    <img src={Conference} alt="" />
                    <span>Conference Interpretation</span>
                  </Link>
                  <Link className="" to="/on/consecutive-interpretation">
                    <img src={Consecutive} alt="" />
                    <span>Consecutive Interpretation</span>
                  </Link>
                  <Link className="" to="/on/simultaneous-interpretation">
                    <img src={Consecutive} alt="" />
                    <span>Simultaneous Interpretation</span>
                  </Link>
                  <Link className="" to="/on/interpretation-services">
                    <img src={Equipment} alt="" />
                    <span>Interpretation Services</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/on/onsite-interpreting">
                    <img src={Onsite} alt="" />
                    <span>Physical Interpretation</span>
                  </Link>
                  <Link className="" to="/on/travel-and-tour-interpretation">
                    <img src={Host} alt="" />
                    <span>Travel & Tour Interpretation</span>
                  </Link>
                  <Link className="" to="/on/video-remote-interpretation">
                    <img src={Conference} alt="" />
                    <span>Video Remote Interpretation</span>
                  </Link>
                  <Link className="" to="/on/over-the-phone-interpretation">
                    <img src={OverPhone} alt="" />
                    <span>Over the Phone Interpretation</span>
                  </Link>
                  <Link className="" to="/industries">
                    <img src={Marketing} alt="" />
                    <span>Industry Coverage</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/on/legal-settings-interpretation">
                    <img src={Privacy} alt="" />
                    <span>Legal Settings Interpretation</span>
                  </Link>
                  <Link className="" to="/on/sign-language-interpretation">
                    <img src={Sign} alt="" />
                    <span>Sign Language Interpretation</span>
                  </Link>
                  <Link className="" to="/on/training-session-interpretation">
                    <img src={Training} alt="" />
                    <span>Training Session Interpretation</span>
                  </Link>
                  <Link className="" to="/on/business-meeting-interpretation">
                    <img src={Marketing} alt="" />
                    <span>Business Meeting Interpretation</span>
                  </Link>
                  <Link className="" to="/on/trade-shows-interpretation">
                    <img src={Press} alt="" />
                    <span>Trade Shows Interpretation</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/on/travel-and-tour-interpretation">
                    <img src={Host} alt="" />
                    <span>Tours Interpretation</span>
                  </Link>
                  <Link className="" to="/on/convention-interpretation">
                    <img src={Convention} alt="" />
                    <span>Convention Interpretation</span>
                  </Link>
                  <Link className="" to="/on/classroom-interpretation">
                    <img src={Classrooms} alt="" />
                    <span>Classrooms Interpretation</span>
                  </Link>
                  <Link className="" to="/languages">
                    <img src={Languages} alt="" />
                    <span>Languages</span>
                  </Link>
                  <Link className="" to="/services">
                    <img src={Services} alt="" />
                    <span>Other Services</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="navBar__languages mx-20">
              <Link
                to="/languages"
                style={{
                  color: languages
                    ? "var(--primary-color)"
                    : !white
                    ? "#333"
                    : "#fff",
                }}
                className="position-relative font-bolder font-sm pointer"
              >
                Languages
              </Link>
              <div className="navBar__line"></div>
              <div className="navBar__links position-absolute mt-10 z-2">
                <div className="navBar__link">
                  <Link className="" to="/translation/arabic-translation">
                    <span>Arabic Translation Service</span>
                  </Link>
                  <Link className="" to="/translation/chinese-translation">
                    <span>Chinese Transalation Service</span>
                  </Link>
                  <Link className="" to="/translation/dutch-translation">
                    <span>Dutch Translation Service</span>
                  </Link>
                  <Link className="" to="/translation/french-translation">
                    <span>French Translation Service</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/translation/german-translation">
                    <span>German Translation Services</span>
                  </Link>
                  <Link className="" to="/translation/greek-translation">
                    <span>Greek Translation Services</span>
                  </Link>
                  <Link className="" to="/translation/italian-translation">
                    <span>Italian Translation Services</span>
                  </Link>
                  <Link className="" to="/translation/polish-translation">
                    <span>Polish Translation Services</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/translation/portuguese-translation">
                    <span>Portuguese Translation Services</span>
                  </Link>
                  <Link className="" to="/translation/russian-translation">
                    <span>Russian Translation Services</span>
                  </Link>
                  <Link className="" to="/translation/spanish-translation">
                    <span>Spanish Translation Services</span>
                  </Link>
                  <Link className="" to="/languages">
                    <span>Other Languages</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="navBar__price mx-20 position-relative">
              <Link
                to="/pricing"
                style={{
                  color: pricing
                    ? "var(--primary-color)"
                    : !white
                    ? "#333"
                    : "#fff",
                }}
                className="position-relative font-bolder font-sm pointer"
              >
                Pricing
              </Link>
              <div className="navBar__line"></div>
              <div className="navBar__links position-absolute mt-10 z-2">
                <div className="navBar__link">
                  <Link className="" to="/pricing/#translation">
                    <img src={Document} alt="" />
                    <span>Translation Rate</span>
                  </Link>
                  <Link className="" to="/pricing/#interpretation">
                    <img src={Classrooms} alt="" />
                    <span>Interpretation Rates</span>
                  </Link>
                  <Link className="" to="/pricing/#equipment">
                    <img src={Card} alt="" />
                    <span>Equipment Rates</span>
                  </Link>
                  <Link className="" to="/pricing/#transcription">
                    <img src={TranscriptRate} alt="" />
                    <span>Transcription Rates</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="navBar__company mx-20">
              <Link
                to="/company"
                style={{
                  color: company
                    ? "var(--primary-color)"
                    : !white
                    ? "#333"
                    : "#fff",
                }}
                className="position-relative font-bolder font-sm pointer"
              >
                The Company
              </Link>
              <div className="navBar__line"></div>
              <div className="navBar__links position-absolute mt-10 z-2">
                <div className="navBar__link">
                  <Link className="" to="/company/#about-us">
                    <img src={About} alt="" />
                    <span>About Us</span>
                  </Link>
                  <Link className="" to="/company/#offices">
                    <img src={Offices} alt="" />
                    <span>Offices/Locations</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/company/#translators">
                    <img src={Photos} alt="" />
                    <span>Photos/Videos</span>
                  </Link>
                  <Link className="" to="/company/#client">
                    <img src={Classrooms} alt="" />
                    <span>Our Clients</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/company/#prefer">
                    <img src={Why} alt="" />
                    <span>Why Choose Us</span>
                  </Link>
                  <Link className="" to="/quote">
                    <img src={Request} alt="" />
                    <span>Request a Quote</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/company/#process">
                    <img src={Process} alt="" />
                    <span>Our Process</span>
                  </Link>
                  <Link className="" to="/company/#translators">
                    <img src={Document} alt="" />
                    <span>Our Translators</span>
                  </Link>
                </div>
                <div className="navBar__link">
                  <Link className="" to="/blog">
                    <img src={Blog} alt="" />
                    <span>Blog</span>
                  </Link>
                  <Link className="" to="/join-us/#faq">
                    <img src={FAQ} alt="" />
                    <span>FAQ</span>
                  </Link>
                </div>
              </div>
            </div>
          </nav>
          <div className="navBar__buttons d-flex align-center">
            {!user && (
              <button
                className="button bg-transparent mr-20"
                style={{ color: white ? "#333" : "#fff" }}
                onClick={logout}
              >
                LOG IN
              </button>
            )}
            {user && (
              <details className="navBar__details position-relative px-20">
                <summary className="d-flex align-center list-none pointer">
                  <div className="holder__logo d-flex align-center justify-center rounded-50">
                    <span className="font-bigger font-bolder text-uppercase">
                      {user.name.split(" ")[0].charAt(0)}
                    </span>
                  </div>
                  <ArrowDropDown className="icon-light-grey" fontSize="large" />
                </summary>
                <div className="navBar__drop position-absolute r-0 mt-20 z-3 box-shadow-lg">
                  <p className="text-capitalise font-big font-bolder text-center px-40 my-10">
                    Hi, {user.name.split(" ")[0]}
                  </p>
                  <div
                    className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer"
                    onClick={handleToDashboard}
                  >
                    <DashboardOutlined fontSize="small" className="mr-20" />
                    <span>Your Dashboard</span>
                  </div>
                  <div
                    className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer"
                    onClick={() => history.push("/settings")}
                  >
                    <SettingsOutlined fontSize="small" className="mr-20" />
                    <span>Settings</span>
                  </div>
                  <div
                    style={{ color: "crimson" }}
                    className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer"
                    onClick={logout}
                  >
                    <ExitToApp fontSize="small" className="mr-20" />
                    <span>Log Out</span>
                  </div>
                </div>
              </details>
            )}
            <Link to="/quote">
              <button className="button bg-orange">INSTANT QUOTE</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="navBar w-100 position-relative z-4">
        <div className="container d-flex align-center justify-end">
          <nav className="navBar__nav d-flex justify-between w-100">
            <div>
              <a
                href="https://www.instagram.com/theofficialoneconverse/"
                target="_blank"
                rel="noreferrer"
                className="mr-20 pointer"
              >
                <Instagram />
              </a>
              <a
                href="https://web.facebook.com/oneconverse/"
                target="_blank"
                rel="noreferrer"
                className="mr-20 pointer"
              >
                <Facebook />
              </a>
              <a
                href="https://twitter.com/Oneconverse1"
                target="_blank"
                rel="noreferrer"
                className="mr-20 pointer"
              >
                <Twitter />
              </a>
              <a
                href="https://www.linkedin.com/company/81468693/admin/"
                target="_blank"
                rel="noreferrer"
                className="mr-20 pointer"
              >
                <LinkedIn />
              </a>
            </div>
            <div>
              <Link className="font-bolder font-xsm pr-10" to="/join-us">
                Join our team
              </Link>
              <Link
                className="font-bolder font-xsm pr-10"
                to="/online-translation"
              >
                Online translation
              </Link>
              <Link className="font-bolder font-xsm pr-10" to="/contact-us">
                Contact Us
              </Link>
            </div>
          </nav>
        </div>
        <div className="d-flex pt-20">
          <div className="container d-flex align-center w-100 justify-between z-3">
            <Link to="/">
              <div className="navBar__logo m-10">
                <img src={Logo} alt="OneConverse" />
              </div>
            </Link>
            <nav className="navBar__menu d-flex">
              <div className="navBar__translation mx-20">
                <Link
                  to="/translation"
                  style={{
                    color: translation
                      ? "var(--primary-color)"
                      : !white
                      ? "#333"
                      : "#fff",
                  }}
                  className="position-relative font-bolder font-sm pointer"
                >
                  Translation
                </Link>
                <div className="navBar__line"></div>
                <div className="navBar__links position-absolute mt-10 z-2">
                  <div className="navBar__link">
                    <Link className="" to="/on/document-translations">
                      <img src={Document} alt="" />
                      <span>Document Translation</span>
                    </Link>
                    <Link className="" to="/on/certificate-translation">
                      <img src={Certificate} alt="" />
                      <span>Certificate Translation</span>
                    </Link>
                    <Link className="" to="/on/covenant-translation">
                      <img src={Education} alt="" />
                      <span>Contract Translation</span>
                    </Link>
                    <Link className="" to="/on/affidavits-translation">
                      <img src={Transcript} alt="" />
                      <span>Affidavitis Translation</span>
                    </Link>
                    <Link className="" to="/services">
                      <img src={Additional} alt="" />
                      <span>Additional Services</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/on/government-translation">
                      <img src={Commercial} alt="" />
                      <span>Government Translation</span>
                    </Link>
                    <Link className="" to="/on/business-document">
                      <img src={Research} alt="" />
                      <span>Business Translation</span>
                    </Link>
                    <Link className="" to="/on/personal-translation">
                      <img src={Personal} alt="" />
                      <span>Personal Translation</span>
                    </Link>
                    <Link className="" to="/on/legal-translation">
                      <img src={Legal} alt="" />
                      <span>Legal Translation</span>
                    </Link>
                    <Link className="" to="/industries">
                      <img src={Industries} alt="" />
                      <span>All Industries</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/on/patents-translations">
                      <img src={Privacy} alt="" />
                      <span>Patents Translation</span>
                    </Link>
                    <Link className="" to="/on/apostile-transltion">
                      <img src={Apostille} alt="" />
                      <span>Apostille Translation</span>
                    </Link>
                    <Link className="" to="/on/notarized-translation">
                      <img src={Notarized} alt="" />
                      <span>Notarized Translation</span>
                    </Link>
                    <Link className="" to="/on/thesis-translations">
                      <img src={Diploma} alt="" />
                      <span>Thesis Translation</span>
                    </Link>
                    <Link className="" to="/on/website-content-translation">
                      <img src={Content} alt="" />
                      <span>Web Content Translation</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/on/marketing-materials-translation">
                      <img src={Marketing} alt="" />
                      <span>Marketing Materials Translation</span>
                    </Link>
                    <Link className="" to="/on/certified-document-translation">
                      <img src={Certified} alt="" />
                      <span>Certified Document Translation</span>
                    </Link>
                    <Link className="" to="/on/sworn-document-translation">
                      <img src={Sworn} alt="" />
                      <span>Sworn Document Translation</span>
                    </Link>
                    <Link className="" to="/on/financial-translation">
                      <img src={Press} alt="" />
                      <span>Financial Translation</span>
                    </Link>
                    <Link className="" to="/on/pledge-translation">
                      <img src={Privacy} alt="" />
                      <span>Pledge Translation</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="navBar__interpreting mx-20">
                <Link
                  to="/interpretation"
                  style={{
                    color: interpretation
                      ? "var(--primary-color)"
                      : !white
                      ? "#333"
                      : "#fff",
                  }}
                  className="position-relative font-bolder font-sm pointer"
                >
                  Interpreting
                </Link>
                <div className="navBar__line"></div>
                <div className="navBar__links position-absolute mt-10 z-2">
                  <div className="navBar__link">
                    <Link className="" to="/on/onsite-interpreting">
                      <img src={Onsite} alt="" />
                      <span>Onsite Interpretation</span>
                    </Link>
                    <Link className="" to="/on/conference-interpretation">
                      <img src={Conference} alt="" />
                      <span>Conference Interpretation</span>
                    </Link>
                    <Link className="" to="/on/consecutive-interpretation">
                      <img src={Consecutive} alt="" />
                      <span>Consecutive Interpretation</span>
                    </Link>
                    <Link className="" to="/on/simultaneous-interpretation">
                      <img src={Consecutive} alt="" />
                      <span>Simultaneous Interpretation</span>
                    </Link>
                    <Link className="" to="/on/interpretation-services">
                      <img src={Equipment} alt="" />
                      <span>Interpretation Services</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/on/onsite-interpreting">
                      <img src={Onsite} alt="" />
                      <span>Physical Interpretation</span>
                    </Link>
                    <Link className="" to="/on/travel-and-tour-interpretation">
                      <img src={Host} alt="" />
                      <span>Travel & Tour Interpretation</span>
                    </Link>
                    <Link className="" to="/on/video-remote-interpretation">
                      <img src={Conference} alt="" />
                      <span>Video Remote Interpretation</span>
                    </Link>
                    <Link className="" to="/on/over-the-phone-interpretation">
                      <img src={OverPhone} alt="" />
                      <span>Over the Phone Interpretation</span>
                    </Link>
                    <Link className="" to="/industries">
                      <img src={Marketing} alt="" />
                      <span>Industry Coverage</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/on/legal-settings-interpretation">
                      <img src={Privacy} alt="" />
                      <span>Legal Settings Interpretation</span>
                    </Link>
                    <Link className="" to="/on/sign-language-interpretation">
                      <img src={Sign} alt="" />
                      <span>Sign Language Interpretation</span>
                    </Link>
                    <Link className="" to="/on/training-session-interpretation">
                      <img src={Training} alt="" />
                      <span>Training Session Interpretation</span>
                    </Link>
                    <Link className="" to="/on/business-meeting-interpretation">
                      <img src={Marketing} alt="" />
                      <span>Business Meeting Interpretation</span>
                    </Link>
                    <Link className="" to="/on/trade-shows-interpretation">
                      <img src={Press} alt="" />
                      <span>Trade Shows Interpretation</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/on/travel-and-tour-interpretation">
                      <img src={Host} alt="" />
                      <span>Tours Interpretation</span>
                    </Link>
                    <Link className="" to="/on/convention-interpretation">
                      <img src={Convention} alt="" />
                      <span>Convention Interpretation</span>
                    </Link>
                    <Link className="" to="/on/classroom-interpretation">
                      <img src={Classrooms} alt="" />
                      <span>Classrooms Interpretation</span>
                    </Link>
                    <Link className="" to="/languages">
                      <img src={Languages} alt="" />
                      <span>Languages</span>
                    </Link>
                    <Link className="" to="/services">
                      <img src={Services} alt="" />
                      <span>Other Services</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="navBar__languages mx-20">
                <Link
                  to="/languages"
                  style={{
                    color: languages
                      ? "var(--primary-color)"
                      : !white
                      ? "#333"
                      : "#fff",
                  }}
                  className="position-relative font-bolder font-sm pointer"
                >
                  Languages
                </Link>
                <div className="navBar__line"></div>
                <div className="navBar__links position-absolute mt-10 z-2">
                  <div className="navBar__link">
                    <Link className="" to="/translation/arabic-translation">
                      <span>Arabic Translation Service</span>
                    </Link>
                    <Link className="" to="/translation/chinese-translation">
                      <span>Chinese Transalation Service</span>
                    </Link>
                    <Link className="" to="/translation/dutch-translation">
                      <span>Dutch Translation Service</span>
                    </Link>
                    <Link className="" to="/translation/french-translation">
                      <span>French Translation Service</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/translation/german-translation">
                      <span>German Translation Services</span>
                    </Link>
                    <Link className="" to="/translation/greek-translation">
                      <span>Greek Translation Services</span>
                    </Link>
                    <Link className="" to="/translation/italian-translation">
                      <span>Italian Translation Services</span>
                    </Link>
                    <Link className="" to="/translation/polish-translation">
                      <span>Polish Translation Services</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/translation/portuguese-translation">
                      <span>Portuguese Translation Services</span>
                    </Link>
                    <Link className="" to="/translation/russian-translation">
                      <span>Russian Translation Services</span>
                    </Link>
                    <Link className="" to="/translation/spanish-translation">
                      <span>Spanish Translation Services</span>
                    </Link>
                    <Link className="" to="/languages">
                      <span>Other Languages</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="navBar__price mx-20 position-relative">
                <Link
                  to="/pricing"
                  style={{
                    color: pricing
                      ? "var(--primary-color)"
                      : !white
                      ? "#333"
                      : "#fff",
                  }}
                  className="position-relative font-bolder font-sm pointer"
                >
                  Pricing
                </Link>
                <div className="navBar__line"></div>
                <div className="navBar__links position-absolute mt-10 z-2">
                  <div className="navBar__link">
                    <Link className="" to="/pricing/#translation">
                      <img src={Document} alt="" />
                      <span>Translation Rate</span>
                    </Link>
                    <Link className="" to="/pricing/#interpretation">
                      <img src={Classrooms} alt="" />
                      <span>Interpretation Rates</span>
                    </Link>
                    <Link className="" to="/pricing/#equipment">
                      <img src={Card} alt="" />
                      <span>Equipment Rates</span>
                    </Link>
                    <Link className="" to="/pricing/#transcription">
                      <img src={TranscriptRate} alt="" />
                      <span>Transcription Rates</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="navBar__company mx-20">
                <Link
                  to="/company"
                  style={{
                    color: company
                      ? "var(--primary-color)"
                      : !white
                      ? "#333"
                      : "#fff",
                  }}
                  className="position-relative font-bolder font-sm pointer"
                >
                  The Company
                </Link>
                <div className="navBar__line"></div>
                <div className="navBar__links position-absolute mt-10 z-2">
                  <div className="navBar__link">
                    <Link className="" to="/company/#about-us">
                      <img src={About} alt="" />
                      <span>About Us</span>
                    </Link>
                    <Link className="" to="/company/#offices">
                      <img src={Offices} alt="" />
                      <span>Offices/Locations</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/company/#translators">
                      <img src={Photos} alt="" />
                      <span>Photos/Videos</span>
                    </Link>
                    <Link className="" to="/company/#client">
                      <img src={Classrooms} alt="" />
                      <span>Our Clients</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/company/#prefer">
                      <img src={Why} alt="" />
                      <span>Why Choose Us</span>
                    </Link>
                    <Link className="" to="/quote">
                      <img src={Request} alt="" />
                      <span>Request a Quote</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/company/#process">
                      <img src={Process} alt="" />
                      <span>Our Process</span>
                    </Link>
                    <Link className="" to="/company/#translators">
                      <img src={Document} alt="" />
                      <span>Our Translators</span>
                    </Link>
                  </div>
                  <div className="navBar__link">
                    <Link className="" to="/blog">
                      <img src={Blog} alt="" />
                      <span>Blog</span>
                    </Link>
                    <Link className="" to="/join-us/#faq">
                      <img src={FAQ} alt="" />
                      <span>FAQ</span>
                    </Link>
                  </div>
                </div>
              </div>
            </nav>
            <div className="navBar__buttons d-flex align-center">
              {!user && (
                <button
                  className="button bg-transparent mr-20"
                  style={{ color: !white ? "#333" : "#fff" }}
                  onClick={logout}
                >
                  LOG IN
                </button>
              )}
              {user && (
                <details className="navBar__details position-relative px-20">
                  <summary className="d-flex align-center list-none pointer">
                    <div className="holder__logo d-flex align-center justify-center rounded-50">
                      <span className="font-bigger font-bolder text-uppercase">
                        {user.name.split(" ")[0].charAt(0)}
                      </span>
                    </div>
                    <ArrowDropDown
                      className="icon-light-grey"
                      fontSize="large"
                    />
                  </summary>
                  <div className="navBar__drop position-absolute r-0 mt-20 z-3 box-shadow-lg">
                    <p className="text-capitalise font-big font-bolder text-center px-40 my-10">
                      Hi, {user.name.split(" ")[0]}
                    </p>
                    <div
                      className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer"
                      onClick={handleToDashboard}
                    >
                      <DashboardOutlined fontSize="small" className="mr-20" />
                      <span>Your Dashboard</span>
                    </div>
                    <div
                      className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer"
                      onClick={() => history.push("/settings")}
                    >
                      <SettingsOutlined fontSize="small" className="mr-20" />
                      <span>Settings</span>
                    </div>
                    <div
                      style={{ color: "crimson" }}
                      className="d-flex align-center font-bold py-10 px-20 w-100 border-top-1 pointer"
                      onClick={logout}
                    >
                      <ExitToApp fontSize="small" className="mr-20" />
                      <span>Log Out</span>
                    </div>
                  </div>
                </details>
              )}
              <Link to="/quote">
                <button className="button bg-orange">INSTANT QUOTE</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="navBar__sm d-flex align-center justify-between bg-black px-20 position-relative z-5">
        <Menu
          className="pointer"
          fontSize="large"
          onClick={() => setShowSide(true)}
        />
        <img src={Logo} alt="" onClick={() => history.push("/")} />
      </div>
      <div className="navBar__sm navBar__sm__scroll position-fixed box-shadow-lg t-0 w-100 d-flex align-center justify-between bg-black px-20 z-5">
        <Menu
          className="pointer"
          fontSize="large"
          onClick={() => setShowSide(true)}
        />
        <img src={Logo} alt="" onClick={() => history.push("/")} />
      </div>
      <div
        style={{ left: showSide ? "0" : "-300px" }}
        className="navBar__side position-fixed h-100 t-0 z-5 overflow-auto"
      >
        <div className="d-flex justify-between align-center p-20 pt-40">
          <span className="font-bolder">Menu</span>
          <Close className="pointer" onClick={() => setShowSide(false)} />
        </div>
        <Link
          to="/"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Home</span>
        </Link>
        <Link
          to="/company"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">About Us</span>
        </Link>
        <Link
          to="/join-us"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Join</span>
        </Link>
        <Link
          to="/translation"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Translation</span>
        </Link>
        <Link
          to="/interpretation"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Interpretation</span>
        </Link>
        <Link
          to="/languages"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Languages</span>
        </Link>
        <Link
          to="/online-translation"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Online Translation</span>
        </Link>
        <Link
          to="/pricing"
          className="d-flex justify-between align-center py-10 px-20"
          onClick={() => setShowSide(false)}
        >
          <span className="font-heavy">Pricing</span>
        </Link>
        {user && (
          <>
            <div className="d-flex justify-between align-center py-10 px-20">
              <span className="font-heavy" onClick={handleToDashboard}>
                Dashboard
              </span>
            </div>
            <div className="d-flex justify-between align-center py-10 px-20">
              <Link to="/settings" className="font-heavy">
                Settings
              </Link>
            </div>
          </>
        )}
        <button
          className="border-0 outline-0 font-big font-bold mt-10"
          onClick={handleToCheckout}
        >
          INSTANT QUOTE
        </button>
        <button
          className="border-0 outline-0 font-big font-bold mt-10"
          style={{
            backgroundColor: !user ? "var(--bg-green)" : "var(--bg-red)",
          }}
          onClick={logout}
        >
          {user ? "LOG OUT" : "LOGIN"}
        </button>
        <div className="d-flex justify-center w-100 mt-10">
          <a
            href="https://www.instagram.com/theofficialoneconverse/"
            target="_blank"
            rel="noreferrer"
            className="mr-20 pointer"
            style={{ color: "var(--bg-dark)" }}
          >
            <Instagram />
          </a>
          <a
            href="https://web.facebook.com/oneconverse/"
            target="_blank"
            rel="noreferrer"
            className="mr-20 pointer"
            style={{ color: "var(--bg-dark)" }}
          >
            <Facebook />
          </a>
          <a
            href="https://www.linkedin.com/company/81468693/admin/"
            target="_blank"
            rel="noreferrer"
            className="mr-20 pointer"
            style={{ color: "var(--bg-dark)" }}
          >
            <LinkedIn />
          </a>
          <a
            href="https://twitter.com/Oneconverse1"
            target="_blank"
            rel="noreferrer"
            className="mr-20 pointer"
            style={{ color: "var(--bg-dark)" }}
          >
            <Twitter />
          </a>
        </div>
      </div>
    </>
  );
};

export default NavBar;
